/*
 * The Entities tab of the Application Detail page (ENTITY-DESIGN.md §6): the entity classes an
 * application defined and its entities, by class or beneath a path, searchable and paged.
 * Read-only -- the application registers its own entities. No jQuery.
 */
import { ajaxModal, ajaxSwap } from '../core/ajax';

const PANE = 'ApplicationEntitiesTab';

function valueOf(id: string): string {
    const el = document.getElementById(id) as HTMLInputElement | HTMLSelectElement | null;
    return el?.value.trim() ?? '';
}

function load(applicationId: number | string, page: number): Promise<void> {
    const params = new URLSearchParams();
    const entityClass = valueOf(`EntitiesClass_${applicationId}`);
    const under = valueOf(`EntitiesUnder_${applicationId}`);
    const search = valueOf(`EntitiesSearch_${applicationId}`);
    if (entityClass) params.set('class', entityClass);
    if (under) params.set('under', under);
    if (search) params.set('search', search);
    if (page > 1) params.set('page', String(page));
    const query = params.toString();
    return ajaxSwap({
        container: PANE,
        url: `Entity/Application/${applicationId}${query ? `?${query}` : ''}`,
        alertTitle: 'Failed to load entities',
    });
}

export const List = {
    /** Search from page 1 with the current class, path and key filters. */
    Search(applicationId: number | string): boolean {
        void load(applicationId, 1);
        return false;
    },

    /** Another page under the current filters. */
    Page(applicationId: number | string, page: number): boolean {
        void load(applicationId, page);
        return false;
    },

    /** A row's path -> the entity's read-only detail in the Application Detail modal. */
    ShowDetail(applicationId: number | string, path: string): boolean {
        void ajaxModal({
            modal: 'ApplicationDetailModal',
            url: `Entity/Application/${applicationId}/Detail?${new URLSearchParams({ path })}`,
            title: null,
            errorTitle: `Entity ${path}`,
            errorMessage: 'The entity failed to load:',
        });
        return false;
    },
};
